"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function generateSourceIdFromURL() {
    var url = window.location.origin;
    return btoa(url); // Simple base64 encoding; swap for SHA if you want stronger obfuscation
}
var scriptTag = document.currentScript;
var origin = window.location.origin;
var allowedOrigins = [
    "http://americanhighschool.org",
    "https://americanhighschool.org",
    "http://www.americanhighschool.org",
    "https://www.americanhighschool.org",
    "https://www.americanhighschool.org/"
];
var widgetConfig = {
    sourceId: (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("data-source-id")) || generateSourceIdFromURL(),
    agentId: (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("data-agent-id")) || "",
    transferAgentId: (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("data-transfer-agent-id")) || "",
    agentName: (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("data-agent-name")) || "",
    oldAgentName: (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("data-agent-name")) || "",
    oldAgentID: (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("data-agent-id")) || "",
    transferAgentName: (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("data-transfer-agent-name")) || "",
    apiKey: '1b07e2d1-c19f-44de-a638-303e755e1477',
    textOne: 'Speak With',
    divId: (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute("data-div-id")) || "ConnexUSVRep-chat",
    // onSite: allowedOrigins.includes(origin),
};
// Optional: attach globally if needed
if (typeof window !== "undefined") {
    window.connexVRepConfig = __assign(__assign({}, window.connexVRepConfig), widgetConfig);
}
exports.default = widgetConfig;
